import { baseUrl } from './baseUrl';
import ajax from './ajax';
import qs from 'qs';

export const http = {
  // 查询是否投稿
  apiHasWork(param) {
    return ajax.get(`${baseUrl}/pu/v1/works?${qs.stringify(param)}`);
  },
  // 查询省市
  apiProvince(param) {
    return ajax.get(`${baseUrl}/pub/v1/province?${qs.stringify(param)}`);
  },
  // 根据省查市
  apiCity(param) {
    return ajax.get(`${baseUrl}/pub/v1/city?${qs.stringify(param)}`);
  },
  // 查询学校
  apiSchool(param) {
    return ajax.get(`${baseUrl}/pub/v1/schoolpcc?${qs.stringify(param)}`);
  },
  // 报名
  apiSignUp(body) {
    return ajax.post(`${baseUrl}/user/signUp`, body);
  },
  // 个人页面查询已报名信息（是否有报，在哪里报的）
  apiIsSign(param) {
    return ajax.get(`${baseUrl}/user?${qs.stringify(param)}`);
  },
  // 查询地图
  apiMap(param) {
    return ajax.get(`${baseUrl}/pu/v1/works/map?${qs.stringify(param)}`);
  },
  // 查询资源
  apiGoods(param) {
    return ajax.get(`${baseUrl}/pu/v1/works/goods?${qs.stringify(param)}`);
  },
  // 查询作品列表
  apiRanking(param) {
    return ajax.get(`${baseUrl}/pub/v1/works/ranking?${qs.stringify(param)}`);
  },
  // 查询作品详情
  apiDetail(param) {
    return ajax.get(`${baseUrl}/pub/v1/works?${qs.stringify(param)}`);
  },
  // 获取分享配置
  shareConfig(param) {
    return ajax.get(
      `${baseUrl}/pu/v1/share/friend/config?${qs.stringify(param)}`
    );
  },
  // 查询游戏内好友列表
  apiFriendList(param) {
    return ajax.get(`${baseUrl}/pu/v1/share/friend?${qs.stringify(param)}`);
  },
  // 查询我的高校
  apiSchoolList(param) {
    return ajax.get(`${baseUrl}/pub/v1/schoolData?${qs.stringify(param)}`);
  },
  // 分享给好友
  apiShareFriend(param) {
    return ajax.post(`${baseUrl}/pu/v1/share/friend?${qs.stringify(param)}`);
  },
  // 分享动态
  apiShareDynamic(param) {
    return ajax.post(`${baseUrl}/pu/v1/moment?${qs.stringify(param)}`);
  },
  // 查询获奖列表123名
  apiTopThree(param) {
    return ajax.get(`${baseUrl}/pub/v1/honor?${qs.stringify(param)}`);
  },
  // 查询其他奖
  apiOtherAward(param) {
    return ajax.get(`${baseUrl}/pub/v1/award?${qs.stringify(param)}`);
  },
  // 查询其他奖
  apiAwardOfID(param) {
    return ajax.get(`${baseUrl}/pub/v1/award/works?${qs.stringify(param)}`);
  },

  // 组织页面查询已报名信息
  apiSignSchoolInfo(param) {
    return ajax.get(`${baseUrl}/user/ncdaMsg?${qs.stringify(param)}`);
  },
  // 获取验证码
  apiSendCode(param) {
    return ajax.get(`${baseUrl}/user/sendCode?${qs.stringify(param)}`);
  },
  // 验证验证码
  apiVerifyCode(param) {
    return ajax.get(`${baseUrl}/user/syncMsg?${qs.stringify(param)}`);
  },
  xxx(body) {
    return ajax.post(`${baseUrl}xxx?${qs.stringify(body)}`);
  }
};
export default http;
